import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FinderButtonModule } from '@finder/shared/components/finder-button/finder-button.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { SquirtResultsComponent } from '@finder/shared/features/squirt/squirt-results/squirt-results.component';

@NgModule({
    imports: [
        CommonModule,
        FinderButtonModule,
        FontIconModule,
    ],
    declarations: [
        SquirtResultsComponent,
    ],
    providers: [],
    exports: [
        SquirtResultsComponent
    ]
})
export class SquirtModule {}
